import React, { useEffect, useState, } from 'react';
import '../admin.list.scss';
import { useTranslation, } from 'react-i18next';
import { useNavigate, } from 'react-router-dom';
import { ColumnsType, SorterResult, } from 'antd/lib/table/interface';
import { IPreviewPhonenumberSetupCost, PermissionEnum, CrudEnum, TPhonenumberSetupCostSortableListCol, } from 'atlas-shared';
import { Table, } from 'antd';
import { AdminListPageHeader, ListPageEmpty, } from '@Components';
import { IWithListProps, IWithListSorterProps, withList, } from '@Hocs/with.list';
import { useAbilities, useAuth, usePhonenumberSetupCosts, useOrganizations, } from '@Hooks';
import { PhonenumberSetupCostListColumns, } from '@Utils';
import { IAuth, } from '@Store';

const PhonenumberSetupCostList = ({ filters, filtersCount, hasFilters, sorter, pagination, setQueryParams, resetQueryParams, }: IWithListProps<IPreviewPhonenumberSetupCost, TPhonenumberSetupCostSortableListCol>) => {
  const { t, } = useTranslation();
  const navigate = useNavigate();
  const auth: IAuth = useAuth();
  const phonenumber_setup_costs = usePhonenumberSetupCosts();
  const abilities = useAbilities();
  const [loading, setLoading, ] = useState<boolean>(true);
  const [rows, setRows, ] = useState<Array<any>>([]);
  const organizations = useOrganizations();
  
  useEffect(() => {
    if (!phonenumber_setup_costs.loaded)
      return;
      
    setLoading(false);
    setRows((phonenumber_setup_costs?.phonenumber_setup_costs || []).map(row => ({ ...row, key: row.id, })));
    
  }, [phonenumber_setup_costs, ]);

  const columns: ColumnsType<IPreviewPhonenumberSetupCost> = React.useMemo(() => {
    return PhonenumberSetupCostListColumns(t, navigate, false, organizations, abilities, auth, [], filters, sorter);
  }, [t, navigate, organizations, abilities, auth, filters, sorter, ]);

  return <div className='admin-list-view'>
    <AdminListPageHeader 
      t={t}
      title={t('PHONENUMBER_SETUP_COSTS')}
      filtersCount={filtersCount}
      reset={() => resetQueryParams()}
      addBtn={abilities.canImplicit(null, CrudEnum.Insert, PermissionEnum.PhonenumberSetupCost) ? { callback: () => navigate('/admin/phonenumber_setup_cost/add'), } : undefined} 
    />
    <div className='table-wrp'>
      <Table
        key={loading ? 1 : 0}
        columns={columns}
        dataSource={rows}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
        }}
        onChange={(pagination, filters, _sorter) => {
          const sorter: Array<SorterResult<any>> = Array.isArray(_sorter) ? _sorter : _sorter?.columnKey ? [_sorter, ] : [];

          setQueryParams({
            pagination: { current: pagination.current as number, pageSize: pagination.pageSize as number, },
            filters: Object.fromEntries(Object.entries(filters).filter(([key, value, ]) => value !== null)),
            sorter: sorter
              .filter(s => !!s.order)
              .map(s => ({ column: s.columnKey as TPhonenumberSetupCostSortableListCol, order: s.order as IWithListSorterProps<IPreviewPhonenumberSetupCost, TPhonenumberSetupCostSortableListCol>['order'], })),
          });
        }}
        locale={{
          emptyText: <ListPageEmpty t={t} hasFilters={hasFilters} hasRows={!!rows.length} reset={() => resetQueryParams()} />,
        }}
      />
    </div>
  </div>;
};

export const PhonenumberSetupCostListView = React.memo(withList<IPreviewPhonenumberSetupCost, TPhonenumberSetupCostSortableListCol>(PhonenumberSetupCostList, {
  filters: {},
  sorter: [{ column: 'created_at', order: 'descend', }, ],
  pagination: { current: 1, pageSize: 10, },
}));
